import xhrService from "../xhrService";

export type BulkUploadResult = { row: number; name: string; status: "created" | "updated" | "failed"; error?: string };

export type BulkUploadApi = {
  downloadTemplate: () => Promise<Blob>;
  upload: (file: File) => Promise<{ created: number; updated?: number; results: BulkUploadResult[] }>;
};

// Template download + upload pair for a `<resource>/bulk-upload` endpoint.
export const bulkUploadApi = (baseUrl: string): BulkUploadApi => ({
  downloadTemplate: () =>
    xhrService.get(`${baseUrl}/template`, { responseType: "blob" }).then(res => res.data),

  upload: file => {
    const formData = new FormData();

    formData.append("file", file);

    return xhrService.post(baseUrl, formData).then(res => res.data);
  },
});

export const clientBulkUploadApi = bulkUploadApi("/api/clients/bulk-upload");
export const projectBulkUploadApi = bulkUploadApi("/api/projects/bulk-upload");
// SW2-2427: one template per asset type, so the type is part of the URL.
export const assetBulkUploadApi = (projectId: number, assetTypeId: number) =>
  bulkUploadApi(`/api/projects/${projectId}/assets/bulk-upload/${assetTypeId}`);
